<div class="container" *transloco="let t">
  <div class="row mt-3 feed-with-filters">
    <div class="col-xl-9 col-lg-8 col-md-7">
      <div class="feed-card-holder">

        @if (featuredCards().length) {
          <h2 class="h4 mb-3">{{ t('news.featured') }}</h2>
          @for (contentItem of featuredCards(); track contentItem.id) {
            <div>
              <multisite-card-cta-horizontal [content]="contentItem" [showDate]="true" [imageTransformations]="'w_275,ar_16:9/'">
              </multisite-card-cta-horizontal>
            </div>
          }
          <hr class="my-4" />
        }

        @for (contentItem of cards(); track contentItem.id) {
          <div>
            <multisite-card-cta-horizontal [content]="contentItem" [showDate]="true" [imageTransformations]="'w_275,ar_16:9/'">
            </multisite-card-cta-horizontal>
          </div>
        }

        @let page = newsPage();
        <div class="my-3">
          @if (page?.meta && page.meta.last_page > 1) {
            <frontend-pagination-type-three
              [classes]="'pg-purple justify-content-center'" [loading]="isAnythingLoading()"
              [meta]="page.meta" [lastPage]="page.meta.last_page"
              [links]="page.links" (changePage)="changePage($event)">
            </frontend-pagination-type-three>
          }
        </div>

        @if (isAnythingLoading()) {
          <multisite-loader-globe-animation-detail width="100" height="100" class="my-3"></multisite-loader-globe-animation-detail>
        }

        @if (failed()) {
          <alert [type]="'danger'">
            <div class="text-center my-5">{{ t('error.something_went_wrong') }}</div>
          </alert>
        }

        @if (!isAnythingLoading() && !failed() && page && !page.items.length && !featuredCards().length) {
          <alert [type]="'warning'">
            <div class="text-center my-5">
              <p class="font-weight-bold">{{ t('common.no_results') }}</p>
              @if (hasChosenFilter()) {
                <p>{{ t('common.try_removing_or_changing_filters') }}</p>
                <button type="button" class="btn btn-primary" (click)="removeFilters()">{{ t('common.remove_filters') }}</button>
              }
            </div>
          </alert>
        }

      </div>
    </div>
    <div class="col-xl-3 col-lg-4 col-md-5">
      <div class="feed-filters">
        <button type="button" class="btn btn-primary w-100 toggle-filters"
          (click)="areFiltersCollapsed.set(!areFiltersCollapsed())" [attr.aria-expanded]="!areFiltersCollapsed()"
          aria-controls="collapseNewsFilters"> {{ t('common.filters') }} <i class="ml-2 fa-solid fa-angle-down"></i>
        </button>
        <div class="filters-body" id="collapseNewsFilters" [collapse]="areFiltersCollapsed()" [isAnimated]="true">

          @if (page?.meta && page.meta.last_page > 1) {
            <frontend-pagination-type-three
              [classes]="'pg-purple justify-content-between mb-0'" [loading]="isAnythingLoading()"
              [meta]="page.meta" [lastPage]="page.meta.last_page"
              [links]="page.links" [simplified]="true" (changePage)="changePage($event)">
            </frontend-pagination-type-three>
          }

          @if (mayChooseSearch) {
            <form class="mt-3" role="search" (ngSubmit)="search()">
              <div class="input-group">
                <input type="search" class="form-control search" name="search"
                  [placeholder]="t('navigation.search')" [attr.aria-label]="t('navigation.search')"
                  minlength="3" maxlength="50" [(ngModel)]="searchText" />
                <button type="submit" class="input-group-text" [attr.aria-label]="t('navigation.search')"
                  [ngClass]="{ disabled: searchText.trim().length > 0 && searchText.trim().length < 3 }">
                  <i class="fa-solid fa-magnifying-glass"></i>
                </button>
              </div>
            </form>
          }

          @if (mayChooseSort) {
            <div class="d-flex flex-column gap-1 filters-border">
              <span class="filters-title">{{ t('common.sort') }}</span>
              <div class="d-flex align-items-center gap-1 flex-wrap">
                @for (option of sorts; track option.sort) {
                  <span class="badge badge-pill clickable" (click)="chooseSort(option.sort)"
                    [ngClass]="{
                      'badge-primary': state().sort === option.sort,
                      'badge-secondary': state().sort !== option.sort,
                      disabled: isAnythingLoading()
                    }">{{ t(option.translationKey) }}</span>
                }
              </div>
            </div>
          }

          @for (group of tagGroups(); track group.type) {
            <div class="filters-border">
              <span class="mb-2 filters-title d-block">{{ t('navigation.filters.' + group.type) }}</span>
              @for (tag of group.tags; track tag.id) {
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" [id]="'news_tag_' + tag.id"
                    [checked]="isTagChosen(tag)" [disabled]="isAnythingLoading()"
                    (change)="chooseTag(tag, $any($event.target).checked)" />
                  <label class="form-check-label" [attr.for]="'news_tag_' + tag.id">{{ tag.name }}</label>
                </div>
              }
            </div>
          }

          @if (mayChooseApplication && applications().length) {
            <div class="filters-border">
              <span class="mb-2 filters-title d-block">{{ t('common.applications') }}</span>
              @for (application of applications(); track application.id) {
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" [id]="'news_application_' + application.id"
                    [checked]="isApplicationChosen(application.slug)" [disabled]="isAnythingLoading()"
                    (change)="chooseApplication(application.slug, $any($event.target).checked)" />
                  <label class="form-check-label" [attr.for]="'news_application_' + application.id">{{ application.name }}</label>
                </div>
              }
            </div>
          }

        </div>
      </div>
    </div>
  </div>
</div>
